import { gql } from '../../../__generated__/graphql/catalog'

export const CREATE_FAVORITE_MUTATION = gql(`
  mutation CreateFavorite($input: CustomerProfileFavoriteInput!, $visitorId: ID) {
    createCustomerProfileFavorite(input: $input, visitorId: $visitorId) {
      ...CustomerProfileFavoritesNode
    }
  }
`)

export const DELETE_FAVORITE_MUTATION = gql(`
  mutation DeleteFavorite($id: ID!, $visitorId: ID) {
    deleteCustomerProfileFavorite(id: $id, visitorId: $visitorId) {
      id
    }
  }
`)
